
import { auth, df } from '@/plugins/firebase'
import state from '@/state'
export default {
  path: '/companies/:companyId/locations/:locationId/registers/:registerId',
  name: 'cashRegister',
  meta: {
    addItemText: '$vuetify.createRegisterReportBtn',
    actions: ['createReport', 'closeBalance'],
    requiresAuth: true,
    sideNav: 'CashRegister',
    topBar: 'AbstractRegisterTopBar'
  },
  beforeEnter: async (to, from, next) => {
    if (to.params.companyId === state.getCurrentCompany().id && to.params.locationId === state.getPointOfSale().id && to.params.registerId === state.getCashRegister().id) {
      next()
    } else {
      const companies = await df.doc(`user_companies/${auth.currentUser.uid}`).get()
      if (
        !companies ||
        !companies.exists ||
        !companies.data() ||
        Object.keys(companies.data().companies).length < 1 ||
        !companies.data().companies[to.params.companyId] ||
        companies.data().companies[to.params.companyId].status !== 'OK'
      ) {
        next({ name: 'catchall' })
        return
      }
      const company = companies.data().companies[to.params.companyId]
      const pointsOfSale = await df.doc(`user_locations/${auth.currentUser.uid}.${company.id}`).get()
      if (
        !pointsOfSale ||
        !pointsOfSale.data() ||
        !pointsOfSale.data().locations ||
        Object.keys(pointsOfSale.data().locations).length < 1 ||
        !pointsOfSale.data().locations[to.params.locationId] ||
        pointsOfSale.data().locations[to.params.locationId].status !== 'OK'
      ) {
        next({ name: 'catchall' })
        return
      }

      const pointOfSale = pointsOfSale.data().locations[to.params.locationId]
      const registers = await df.doc(`user_cash_registers/${auth.currentUser.uid}.${to.params.companyId}.${to.params.locationId}`).get()
      if (
        !registers ||
        !registers.data() ||
        !registers.data().cash_registers ||
        Object.keys(registers.data().cash_registers).length < 1 ||
        !registers.data().cash_registers[to.params.registerId] ||
        registers.data().cash_registers[to.params.registerId].status !== 'OK'
      ) {
        next({ name: 'catchall' })
        return
      }
      const register = registers.data().cash_registers[to.params.registerId]

      // Fetch additional company details including eRacun configuration
      try {
        console.log('Cash-Register Router - Fetching company details for:', to.params.companyId)
        const companyDetails = await df.doc(`companies/${to.params.companyId}`).get()
        console.log('Cash-Register Router - Company details exists:', companyDetails.exists)
        if (companyDetails.exists) {
          const companyData = companyDetails.data()
          console.log('Cash-Register Router - Company data:', companyData)
          console.log('Cash-Register Router - Company eRacun in data:', companyData.eracun)
          // Merge eRacun configuration from companies collection
          if (companyData.eracun) {
            company.eracun = companyData.eracun
            console.log('Cash-Register Router - eRacun merged into company:', company.eracun)
          } else {
            console.log('Cash-Register Router - No eRacun data found in company document')
          }
        } else {
          console.log('Cash-Register Router - Company document does not exist')
        }
      } catch (error) {
        console.warn('Cash-Register Router - Could not fetch company details:', error)
      }

      state.setCurrentCompany(company)
      state.setAppTitle(company.name)
      state.setPointOfSale(pointOfSale)
      state.setCashRegister(register)
      next()
    }
  },
  // component: () => import(/* webpackChunkName: "login" */ getCashRegister())
  // component: () => import(/* webpackChunkName: "login" */ 'sprintf("I pity the %s", hello)')

  component: () => import(/* webpackChunkName: "login" */ '@/modules/cash-register/AbstractRegister'),
  children: [
    {
      path: '/companies/:companyId/locations/:locationId/registers/:registerId/fiscalizationEracun',
      name: 'cashRegister.fiscalizationEracun',
      component: () => import(/* webpackChunkName: "FiscalizationEracun" */ '@/modules/company/components/fiscalization-eracun/FiscalizationEracun'),
      meta: {
        title: 'Fiskalizacija i E-račun',
        noAddButton: true,
        filterSearch: false,
        requiresAuth: true,
        removeSearch: true,
        sideNav: 'CashRegister',
        topBar: 'AbstractRegisterTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/registers/:registerId/businessSettings',
      name: 'cashRegister.businessSettings',
      component: () => import(/* webpackChunkName: "" */ '@/modules/company/components/business-settings/BusinessSettings'),
      meta: {
        title: 'Prodajna mjesta i blagajne',
        filterSearch: false,
        requiresAuth: true,
        removeSearch: true,
        sideNav: 'CashRegister',
        topBar: 'AbstractRegisterTopBar'
      }
    },
    {
      path: '/companies/:companyId/locations/:locationId/registers/:registerId/items/kpd-sifra',
      name: 'cashRegister.items.kpd',
      meta: {
        title: 'KPD Šifre',
        noAddButton: true,
        requiresAuth: true,
        filterSearch: false,
        sideNav: 'CashRegister',
        topBar: 'AbstractRegisterTopBar'
      },
      component: () => import(/* webpackChunkName: "KpdSifra" */ '@/modules/company/components/kpd-sifra/KpdSifra')
    },
    {
      path: '/companies/:companyId/locations/:locationId/registers/:registerId/kalkulacija',
      name: 'cashRegister.warehouseModule.kalkulacija',
      component: () => import(/* webpackChunkName: "Warehouse" */ '@/modules/point-of-sale/components/warehouse/warehouse-module/Kalkulacija'),
      meta: {
        noAddButton: true,
        removeSearch: true,
        removeGrid: true,
        title: 'Kalkulacija',
        filterSearch: false,
        requiresAuth: true,
        sideNav: 'CashRegister',
        topBar: 'AbstractRegisterTopBar'
      }
    }
  ]
}
